import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const OptionAlreadyExistsInfoIcon: React.FC = () => {
  return (
    <Tooltip
      title="Options with the same letters but different capitalization or spacing are considered duplicates."
      arrow
      placement="bottom"
    >
      <IconButton
        size="small"
        aria-label="Option duplicate info"
        tabIndex={-1}
        sx={{
          p: 0.25,
          ml: 0.5,
          color: 'error.main',
          cursor: 'pointer',
          '&:hover': {
            bgcolor: 'rgba(239, 68, 68, 0.08)',
            color: 'error.dark',
          },
        }}
      >
        <InfoOutlinedIcon sx={{ fontSize: '0.9rem' }} />
      </IconButton>
    </Tooltip>
  );
};
